
if ( typeof VideoBackgroundElement !== 'function' ) {

  class VideoBackgroundElement extends HTMLElement {

    constructor(){

      super();

      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');
      const video = this.querySelector('video');
      if ( !video ) {
        return;
      }

      this._hasLoaded = false;

      const markLoaded = () => {
        if ( this._hasLoaded ) {
          return;
        }
        this._hasLoaded = true;
        this.classList.add('loaded');
        this.dispatchEvent(this._eventSuccess);
      };

      const loadSources = () => {
        video.querySelectorAll('source').forEach(elm=>{
          if ( elm.dataset.src && elm.src !== elm.dataset.src ) {
            elm.src = elm.dataset.src;
          }
        });
        video.load();
      };

      const playVideo = () => {
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('playsinline', '');

        const playPromise = video.play();
        if ( playPromise && typeof playPromise.catch === 'function' ) {
          playPromise.catch(()=>{
            if ( video.readyState >= 2 ) {
              markLoaded();
            } else {
              this.switchFallback();
            }
          });
        }
      };

      video.addEventListener('error', e=>{
        this.switchFallback();
      });
      video.addEventListener('loadeddata', ()=>{
        markLoaded();
      });
      video.addEventListener('canplay', ()=>{
        markLoaded();
      });
      video.addEventListener('playing', e=>{
        markLoaded();
      });
      video.addEventListener('stalled', e=>{
        if ( ! this._hasLoaded ) {
          this.switchFallback();
        }
      });

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        if ( ( entries[0].target.querySelector('video-background-element') && ! entries[0].target.querySelector('video-background-element').classList.contains('loaded') ) || ( entries[0].tagName == 'video-background-element') && ! entries[0].target.classList.contains('loaded') ) {
          loadSources();
          playVideo();
        }
        observer.unobserve(this);
      }

      if ( this.getBoundingClientRect().y < window.innerHeight || this.parentNode.getBoundingClientRect().y < window.innerHeight ) {
        loadSources();
        playVideo();
      } else {
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this);
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this.parentElement);
      }
      
    }

    switchFallback(){
      if ( this._fallbackShown ) {
        return;
      }
      this._fallbackShown = true;
      const fallback = this.parentElement.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);
      if ( fallback ) {
        fallback.append(fallback.querySelector('template').content.cloneNode(true));
        fallback.querySelector('img').setAttribute('srcset', fallback.querySelector('img').getAttribute('srcset'));
      }
      this.dispatchEvent(this._eventFail);
    }

  }

  if ( typeof customElements.get('video-background-element') == 'undefined' ) {
    customElements.define('video-background-element', VideoBackgroundElement);
  }

}

document.addEventListener('shopify:section:load', e=>{
  if ( e.target.classList.contains('mount-video-background') ) {
    setTimeout(()=>{
      e.target.querySelectorAll('video-background-element').forEach(elm=>{
        const video = elm.querySelector('video');
        if ( !video ) {
          return;
        }
        elm.querySelectorAll('source').forEach(source=>{
          source.src = source.dataset.src;
        });
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.load();
        video.play()?.catch(()=>{});
      });
    }, 500);
  }
});
